module.exports = __webpack_public_path__ + "img/tab_music_icon.6d9d6aa1.svg";